import React from "react";
import { sortItemsByLabel } from "../../utils/CompareUtils";

interface BaseDropdownProps {
    label: string;
    options: { value: string | number; label: string }[]; // Supports both string and number values
    selectedValue: string | number | null;
    onChange: (value: string | number | null) => void;
    placeholder?: string;
    loading?: boolean;
    disabled?: boolean;
    required?: boolean;
    id?: string;
}

const BaseDropdown: React.FC<BaseDropdownProps> = ({
                                                       label,
                                                       options,
                                                       selectedValue,
                                                       onChange,
                                                       placeholder = "Select...",
                                                       loading = false,
                                                       disabled = false,
                                                       required = false,
                                                       id = "dropdown",
                                                   }) => {
    // Sort options alphabetically by label
    const sortedOptions = sortItemsByLabel(options);
    return (
        <div className="input mb-4 w-full">
            <label htmlFor={id}>
                {label} {required && <span className="text-red-600">*</span>}
            </label>

            <select
                id={id}
                value={selectedValue !== null ? selectedValue.toString() : ""}
                onChange={(e) =>
                    onChange(e.target.value ?
                        (isNaN(Number(e.target.value)) ? e.target.value : Number(e.target.value)) : null)
                }
                disabled={disabled}
                className="w-full px-4 py-2 border border-gray-300 dark:border-gray-600 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 dark:focus:ring-blue-400 transition duration-300 ease-in-out"
            >
                <option className="text-gray-600 dark:text-gray-300" value="">
                    {placeholder}
                </option>
                {loading ? (
                    <option className="text-gray-500 dark:text-gray-400" disabled>Loading...</option>
                ) : (
                    sortedOptions.map((option) => (
                        <option key={option.value} value={option.value}
                                className="text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-700">
                            {option.label}
                        </option>
                    ))
                )}
            </select>
        </div>
    );
};

export default BaseDropdown;